import Button from "../components/Reusable/Button";
import Card from "../components/Reusable/Card";

const Form = ({ handleSubmit, handleFormSubmit, setError, buttonLabel, isLoading, children }: any) => {
  return (
    <>
      <Card>
        <>
          <form onSubmit={handleSubmit((data: any) => handleFormSubmit(data, setError))} autoComplete="off">
            {children}
            <div className="flex justify-end w-full">
              <div className="w-[100px] mr-4">
                <Button label={buttonLabel} isLoading={isLoading} />
              </div>
            </div>
          </form>
        </>
      </Card>
    </>
  );
};

export default Form;
